require('intersection-observer');

export default class ImgLazyLoad {
  constructor() {
    window.addEventListener('DOMContentLoaded', this.lazyLoad);
    window.infinityscroll.on('new-content-loaded', this.lazyLoad);
  }

  /**
   * Observes all images with css class `lazy` and load the full size
   * when they are within 100px from the bottom of the viewport
   */
  // Checking native lazy loading browser support
  lazyLoad() {
    if ('loading' in HTMLImageElement.prototype) {
      console.log('Using native lazy load');
      const lazyEls = document.querySelectorAll('img[loading=lazy]');
      lazyEls.forEach(function (lazyEl) {
        const hasSrcSet = lazyEl.hasAttribute('data-srcset');
        if (hasSrcSet && lazyEl.getAttribute('data-srcset')) {
          lazyEl.setAttribute('srcset', lazyEl.getAttribute('data-srcset'));
        } else {
          lazyEl.setAttribute('src', lazyEl.getAttribute('data-src'));
        }
      });
    } else {
      console.log('Using own lazy load');
      const observer = new IntersectionObserver(
        (entries, imgObserver) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const image = entry.target;
              const hasSrcSet = image.hasAttribute('data-srcset');
              if (hasSrcSet && image.dataset.srcset) {
                image.srcset = image.dataset.srcset;
              } else {
                image.src = image.dataset.src;
              }
              image.removeAttribute('width');
              image.classList.remove('lazy');
              imgObserver.unobserve(image);
            }
          });
        },
        { rootMargin: '0px 0px 100px 0px' }
      );
      const images = document.querySelectorAll('.lazy');
      images.forEach((image) => {
        observer.observe(image);
      });
    }
  }
}
